class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      event.preventDefault();
      this.closest("cart-items").updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    //カートページ描画時に最大販売数量を超過している商品があれば数量を正す
    const updatesToFix = this.extractItemsOverPurchaseLimit();
    if (updatesToFix) {
      this.fixQuantity(updatesToFix);
    }

    this.lineItemStatusElement = document.getElementById(
      "shopping-cart-line-item-status"
    );

    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]')
    ).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0
    );

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener("change", this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute("name"),
      event.target
    );
  }

  /**
   * カート内の各商品の数量をチェックし、最大販売数量を超過しているものを抽出する
   * @returns {Object|null} 更新が必要なバリアントIDと最大販売数量のペア、超過が無い場合はnullで返却
   */
  extractItemsOverPurchaseLimit() {
    const overMaxQuantityItems = {};

    this.querySelectorAll(".c-cart-item__info").forEach((item) => {
      const quantityLimit = parseInt(
        item.querySelector(".limit-purchase-prod").value,
      );
      const currentQuantity = item.querySelector('[name="updates[]"]');

      const variantId = item.closest(".cart-item").dataset.id;

      if (quantityLimit && parseInt(currentQuantity.value) > quantityLimit) {
        overMaxQuantityItems[variantId] = quantityLimit;
      }
    });
    return Object.keys(overMaxQuantityItems).length > 0
      ? overMaxQuantityItems
      : null;
  }

  /**
   * 最大販売数量を超過している商品を一括修正する
   * @param {Object} overMaxQuantityItems 更新対象のバリアントIDと数量のオブジェクト
   */
  fixQuantity(overMaxQuantityItems) {
    this.enableLoading();

    const sectionsId = this.getSectionsToRender()
      .map((section) => section.section)
      .join(",");
    const body = JSON.stringify({
      updates: overMaxQuantityItems,
    });
    fetch(`${routes.cart_update_url}?sections=${sectionsId}`, {
      ...fetchConfig(),
      method: "POST",
      body,
    })
      .then((response) => response.json())
      .then((state) => {
        this.getSectionsToRender().forEach((section) => {
          const element =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);
          element.innerHTML = this.getSectionInnerHTML(
            state.sections[section.section],
            section.selector,
          );
        });
      })
      .catch((error) => console.error(error))
      .finally(() => {
        this.updateTotals();
        this.disableLoading();
      });
  }

  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-contents",
      },
    ];
  }

  async updateQuantity(line, quantity, name, currentTarget) {
    console.log("updating quantity");
    this.enableLoading(line);
    const parent = currentTarget.closest(".c-cart-item__info");
    const qtyBeforeChange = quantity;

    if (parent.querySelector(".limit-purchase-prod") != null) {
      const qtyLimit = parseInt(
        parent.querySelector(".limit-purchase-prod").value
      );

      if (quantity > qtyLimit) {
        quantity = qtyLimit;
      }
    } else {
      quantity = quantity;
    }

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle("is-empty", parsedState.item_count === 0);

        // 獲得予定ポイントを更新
        const items = parsedState.items ?? parsedState.cart?.items ?? [];
        if (items.length > 0) {
          const pointUtil = new PointUtil();
          const cartVariants = items.map((item) => ({
            id: String(item.variant_id),
            amount: (item.final_line_price ?? item.line_price) / 100,
          }));
          pointUtil.displayWillGetPoints(cartVariants, ".cart_point-ratio .count", { alignRight: true });
        }

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        this.updateLiveRegions(line, qtyBeforeChange, parent);

        //数量変更時に通常商品⇔予約商品の状態変化が起きたかどうかを差分比較で検知する
        let isStatusChanged = false;
        document
          .querySelectorAll('.quantity-button[name="plus"]')
          .forEach((btn) => {
            const currentProp =
              btn.getAttribute("data-pre-order-prop") || "false";
            const latestMeta =
              btn.getAttribute("data-pre-order-meta") || "false";
            if (currentProp !== latestMeta) {
              isStatusChanged = true;
            }
          });

          //差分があった場合は画面リロード
        if (isStatusChanged) {
          window.location.reload();
          return;
        }

        const loggedIn = document.getElementById("js-loggedIn").value;
        if (loggedIn == "true") this.checkProdPreOrder();
        const lineItem = document.getElementById(`CartItem-${line}`);
        //if (lineItem) lineItem.querySelector(`[name="${name}"]`).focus();
        this.disableLoading();
        this.updateTotals();
      })
      .catch(() => {
        this.querySelectorAll(".loading-overlay").forEach((overlay) =>
          overlay.classList.add("hidden")
        );
        console.log(window.cartStrings.error);
        this.disableLoading();
      });
  }

  updateLiveRegions(line, itemCount, parent) {
    if (parent.querySelector(".limit-purchase-prod") != null) {
      const qtyLimit = parseInt(
        parent.querySelector(".limit-purchase-prod").value
      );

      if (itemCount > qtyLimit) {
        parent.querySelector(".plus").classList.add("inactive");
        parent.querySelector(".plus").setAttribute("disabled", "");
        document
          .getElementById(`Line-item-error-${line}`)
          .querySelector(".cart-item__error-text")
          .removeAttribute("hidden");
      } else {
        parent.querySelector(".plus").classList.remove("inactive");
        parent.querySelector(".plus").removeAttribute("disabled");
        document
          .getElementById(`Line-item-error-${line}`)
          .querySelector(".cart-item__error-text")
          .setAttribute("hidden", "");
      }
    }
  }

  checkProdPreOrder() {
    let preOrderProd = false;
    let normalProd = false;

    document.querySelectorAll(".cart-item").forEach((item, i) => {
      // 販売元が「ノベルティ/ラッピング」の場合、購入制限の処理から除外
      const valIsNoveltyWrapping = item.querySelector(".is-novelty-wrapping");
      if(valIsNoveltyWrapping.value === "true") return;
      
      const valPreOrder = item.querySelector(".mark-prod");
      if (valPreOrder != null) {
        if (item.querySelector(".mark-prod").value === "true") {
          preOrderProd = true;
        }
      } else {
        normalProd = true;
      }
    });

    if (preOrderProd && normalProd) {
      document
        .querySelector(".message-pre-order")
        .removeAttribute("hidden", "");
      document
        .querySelector('.cart button[name="checkout"]')
        .setAttribute("disabled", "");
    } else {
      document.querySelector(".message-pre-order").setAttribute("hidden", "");
      document
        .querySelector('.cart button[name="checkout"]')
        .removeAttribute("disabled");
    }
  }

  updateTotals() {
    $.ajax({
      type: "GET",
      url: "/cart.js",
      dataType: "json",
    }).done(function (response) {
      let price = (response.items_subtotal_price * 0.01).toString();
      price.length > 3
        ? (price = price.slice(0, -3) + "," + price.slice(-3))
        : "";
      $(".c-badge").html(response.item_count);
      $(".p-cart-price").html(`¥${price}`);
      $(".item-count").html(`カートに入ってる商品 : ${response.item_count} 点`);
      const shippingLimit = WEGO.freeShippingThreshold;
      const total = response.total_price / 100;
      console.log(total);

      // データ属性からLiquidの判定結果を取得
      const shippingInfo = document.getElementById('shipping-info');
      const isFreeShippingDay = shippingInfo.getAttribute('data-is-free-shipping-day') === 'true';
      const isScheduledFreeShipping = shippingInfo.getAttribute('data-is-scheduled-free-shipping') === 'true';
      
      if (total >= shippingLimit || isFreeShippingDay || isScheduledFreeShipping) {
        $("#free-shipping-note").text("このままのご注文で送料無料になります");
      } else {
        const toFreeShippping = shippingLimit - total;
        $("#free-shipping-note").text(`あと${toFreeShippping}円で送料無料`);
      }
    });
  }

  getPointRatio() {
    const pointRatio = $("#cart_point").data("point-ratio");
    return pointRatio;
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    document
      .getElementById("main-cart-items")
      .classList.add("cart__items--disabled");
    this.querySelectorAll(`#CartItem-${line} .loading-overlay`).forEach(
      (overlay) => overlay.classList.remove("hidden")
    );
    document.activeElement.blur();
  }

  disableLoading() {
    document
      .getElementById("main-cart-items")
      .classList.remove("cart__items--disabled");
  }
}

customElements.define("cart-items", CartItems);
